import React from "react";
import { IconProps } from "../interface";
import omit from "@/utils/omit";

const IconLike = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-like"
    {...omit(props, ["className"])}
  >
    <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_540_213)" />
    <path
      d="M16.0544 7.15312L16.4632 6.31312C16.4697 6.29814 16.4805 6.28538 16.4942 6.27642C16.5079 6.26747 16.5238 6.2627 16.5402 6.2627C16.5565 6.2627 16.5725 6.26747 16.5862 6.27642C16.5999 6.28538 16.6107 6.29814 16.6172 6.31312L17.0316 7.15312C17.0375 7.16579 17.0465 7.17678 17.0578 7.18509C17.069 7.1934 17.0822 7.19878 17.096 7.20072L18.0172 7.32952C18.0333 7.33125 18.0485 7.33759 18.0611 7.34778C18.0737 7.35796 18.083 7.37156 18.0881 7.38694C18.0931 7.40232 18.0936 7.41882 18.0894 7.43446C18.0853 7.45011 18.0768 7.46423 18.0648 7.47512L17.4012 8.12752C17.3911 8.13705 17.3835 8.14895 17.3791 8.16215C17.3747 8.17534 17.3736 8.18942 17.376 8.20312L17.5356 9.11872C17.5387 9.13443 17.5372 9.15069 17.5314 9.16559C17.5255 9.18048 17.5155 9.1934 17.5026 9.20281C17.4896 9.21223 17.4743 9.21775 17.4583 9.21872C17.4423 9.2197 17.4264 9.21609 17.4124 9.20832L16.5864 8.77992C16.5743 8.77355 16.5609 8.77022 16.5472 8.77022C16.5335 8.77022 16.5201 8.77355 16.508 8.77992L15.6876 9.19992C15.6736 9.20769 15.6577 9.2113 15.6417 9.21032C15.6257 9.20935 15.6104 9.20383 15.5974 9.19441C15.5845 9.185 15.5745 9.17208 15.5686 9.15719C15.5628 9.14229 15.5613 9.12603 15.5644 9.11032L15.7184 8.19192C15.7208 8.17822 15.7197 8.16414 15.7153 8.15095C15.7109 8.13775 15.7033 8.12585 15.6932 8.11632L15.024 7.48352C15.0117 7.47211 15.0031 7.45727 14.9993 7.44091C14.9955 7.42455 14.9967 7.40744 15.0027 7.39176C15.0087 7.37609 15.0193 7.36258 15.0331 7.35299C15.0469 7.34339 15.0632 7.33814 15.08 7.33792L15.9984 7.20072C16.0107 7.19755 16.0222 7.19162 16.0319 7.18337C16.0416 7.17513 16.0493 7.16478 16.0544 7.15312Z"
      fill="white"
    />
    <path
      d="M6.63521 11.3953H8.28721C8.52241 11.3953 8.64001 11.5129 8.64001 11.7481V17.1941C8.64001 17.4293 8.52241 17.5469 8.28721 17.5469H6.63521C6.40001 17.5469 6.28241 17.4293 6.28241 17.1941V11.7481C6.28241 11.5129 6.40001 11.3953 6.63521 11.3953Z"
      fill="white"
    />
    <path
      d="M12.28 7.68243C12 8.12763 12 8.86403 11.7788 9.38203C11.5722 9.89676 11.2391 10.3511 10.8104 10.703C10.3817 11.0549 9.87112 11.293 9.32599 11.3952V17.5552H15.2844C15.4727 17.553 15.6555 17.4911 15.8065 17.3784C15.9574 17.2657 16.0687 17.108 16.1244 16.928L17.306 13.12C17.3669 12.9216 17.3803 12.7117 17.3453 12.5071C17.3104 12.3025 17.2279 12.109 17.1045 11.9421C16.9812 11.7751 16.8204 11.6395 16.6351 11.546C16.4498 11.4525 16.2451 11.4037 16.0376 11.4036H13.1004C13.1004 11.4036 14.52 9.50243 14.0468 8.08003C13.9987 7.87922 13.8913 7.69755 13.7384 7.55871C13.5856 7.41986 13.3945 7.33028 13.19 7.30163C13.0176 7.26442 12.8379 7.28098 12.6752 7.34907C12.5124 7.41716 12.3745 7.53351 12.28 7.68243Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_540_213"
        x1="0"
        y1="12"
        x2="24"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8400" />
        <stop offset="0.5" stopColor="#FB5A90" />
      </linearGradient>
    </defs>
  </svg>
));

IconLike.displayName = "IconLike";

export default IconLike;
